import type { AnalyticsProvider, AnalyticsContext } from '../analytics';
import { mixpanelService } from '../mixpanelService';
import { getMixpanelConfig } from '../../../config/mixpanel';
import { getMixpanelIdbReady } from '../mixpanelIdbState';

export class MixpanelProvider implements AnalyticsProvider {
  readonly name = 'mixpanel';

  async init(_ctx: AnalyticsContext): Promise<void> {
    // Await the IDB sanitize that was kicked off eagerly in index.tsx so the
    // repair completes before mixpanel.init() runs.  getMixpanelIdbReady()
    // lives in a side-effect-free state module — no circular dependency.
    await getMixpanelIdbReady();
    const config = await getMixpanelConfig();
    if (!config) return;
    await mixpanelService.init(config);
  }

  track(event: string, props: Record<string, unknown>): void {
    mixpanelService.track(event, props as Record<string, any>);
  }

  identify(userId: string, traits?: Record<string, unknown>): void {
    mixpanelService.identify(userId);
    if (traits && Object.keys(traits).length > 0) {
      mixpanelService.setUserProperties(traits as Record<string, any>);
    }
  }

  page(path: string, props?: Record<string, unknown>): void {
    mixpanelService.track('Page View', { page_path: path, ...props });
  }

  reset(): void {
    mixpanelService.reset();
  }

  async flush(): Promise<void> {
    await mixpanelService.flushEvents();
  }
}
